require('styles/App.scss');

import React from 'react';
import Prismic from 'prismic-javascript';
import cookie from 'react-cookies';
import { isIOS } from "react-device-detect";
import Header from './HeaderComponent';
import Projects from './ProjectsComponent';
import SmileComponent from './smile-detector/SmileComponent';

const apiEndpoint = 'https://aeai.cdn.prismic.io/api/v2'
const apiToken = "MC5YVEdWUkJBQUFHY2JJa2li.V--_vTEY77-977-9EE7vv73vv73vv73vv71L77-9UWDvv71h77-9fu-_vT5b77-977-9G2oP77-9UnpY";

class AppComponent extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			data: null,
			didSmile: cookie.load('didSmile')
		}
	}

	componentDidMount(){
		const self = this
		let api
		Prismic.getApi(apiEndpoint, {accessToken: apiToken}).then(function (_api) {
			api = _api
			return api.query(
				Prismic.Predicates.at('document.type', 'projects'),
				{ 
					orderings : '[my.projects.year desc, my.projects.title desc]',
					fetchLinks : ['category.name', 'category.color'],
					pageSize : 100 
				}
			);
		}).then(function (response) {
			console.log("Documents: ", response.results);
			const projets = response.results.map(project => project.data)
			// console.log(projets)
			// projets.sort(project => project.sticky = "true")
			self.setState({
				projects: projets
			})
			
			api.query(
				Prismic.Predicates.at('document.type', 'category'),
				{orderings : '[my.category.name]'}
			).then(function(response) {
				// console.log("Documents: ", response.results);
				self.setState({
					categories: response.results
				})
				
				api.getSingle('options').then(function(document) {
					// console.log("Documents: ", document);
					self.setState({
						options: document.data
					}, )
				});

			});
		}, function (err) {
		    console.log("Something went wrong: ", err);
		});
  
		// fetch('data/projects.json')
		// 	.then(res => res.json())
		// 	.then(data => {
		// 		//console.log(data)
		// 		this.setState({
		// 			data: data
		// 		})
		// 	})

		PubSub.subscribe('DID_SMILE', (e,d) => {
			this.setState({
				didSmile: true
			})
			cookie.save(
				'didSmile', 
				true, 
				{ 
					path: '/',
					maxAge: 31556926
				}
			)
		});
	}

	// _get()

  	render() {
  		if(!this.state.options){
			return (
		  		<div id="page">
		  			<div>Loading...</div>
		  		</div>
			)
  		}else{
  			const {data, projects, categories, options} = this.state
// console.log(options)
  			let smile = ''
  			if(!this.state.didSmile){
  				smile = isIOS == false && <SmileComponent />
  			}
			  
			//let smile = <SmileComponent />

  			// /if(this.state.didSmile)smile = '';
			return (
		  		<div id="page">
		  			<div className="row">
			  			<div className="col-md-6 infos">
							  <Header 
							  infos={options}
							  categories={categories}
							  />
			  			</div>
			  			<div className="col-md-6 projects">
			  				<Projects projects={projects}/>
			  			</div>
		  			</div>
		  			{smile}
		  		</div>
			)
  		}
    	
  	}
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js